// extracted by mini-css-extract-plugin
module.exports = {"c_card":"style_c_card__2oYTL","imageDiv":"style_imageDiv__2B4eh","informationDiv":"style_informationDiv__UQfj8"};